import styled from 'styled-components';

import backgroundmobile from '../../assets/login-back-user-mobile.jpg';
import backgroundTablet from '../../assets/login-back-user-tablet.jpg';
import backgroundWeb from '../../assets/login-back-user-web.jpg';

export const Content = styled.div`
  display: flex;
  width: 550px;
  justify-content: space-between;
  align-items: center;
  & div.logo {
    img {
      width: 180px;
    }
  }

  & form {
    display: flex;
    width: 50%;
    flex-direction: column;
    align-items: center;

    & h2 {
      color: #0C5C75;
      font-size: 1.5em;
      margin-bottom: 10px;
      text-align: center;
    }

    & p {
      color: #0C5C75;
      font-size: 0.85em;
      margin-bottom: 20px;
      text-align: center;
      line-height: 1.4;
    }

    & > div {
      width: 100%;
      & + div {
        margin-top: 10px;
      }
    }
    & a {
      width: 100%;
      color: #0C5C75;
      font-size: 0.8em;
      font-weight: 600;
      text-align: center;
      margin-top: 15px;
      &:hover {
        cursor: pointer;
        font-weight: 700;
      }
    }
    & p.error {
      color: #c24727;
      font-size: 1em;
      text-align: center;
      font-weight: 500;
    }
    & button {
      margin-top: 10px;
      width: 70%;
    }
  }

  @media (max-width: 1023px) {
    flex-direction: column;

    & div.logo {
      img {
        margin-bottom: 20px;
      }
    }

    & form {
      width: 60%;
    }
  }
  @media (max-width: 768px) {
    & div.logo {
      img {
      }
    }
    & form {
      width: 62%;
    }
  }
`;

export const Background = styled.div`
  height: 100dvh;
  flex: 1;
  display: flex;
  background: url(${backgroundWeb}) no-repeat center;
  background-size: cover;
  justify-content: center;
  align-items: center;

  @media (max-width: 1023px) {
    background: url(${backgroundTablet}) no-repeat center;
    background-size: cover;
  }

  @media (max-width: 768px) {
    background: url(${backgroundmobile}) no-repeat center;
    background-size: cover;
  }
`;
